/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { TypesExportPayload } from "../models/types-export-payload";
import { US_PreFilter } from "../models/us_pre-filter";
import { PreFilterExpandedDetails } from "../models/pre-filter-expanded-details";
import { PreFilter } from "../models/pre-filter";
import { PreFilterValue } from "../models/pre-filter-value";
import { SetRegionsPayload } from "../models/set-regions-payload";
import { SetOccupationsPayload } from "../models/set-occupations-payload";
import { SetIndustriesPayload } from "../models/set-industries-payload";
import { PreFilterInteractive } from "../models/pre-filter-interactive";
@Injectable({
  providedIn: "root",
})
class PreFilterService extends __BaseService {
  static readonly preFilterGetIndustrySectorPageJsonPath =
    "/api/PreFilter/GetIndustrySectorPageJson";
  static readonly preFilterGetIndustryIndustryPageJsonPath =
    "/api/PreFilter/GetIndustryIndustryPageJson";
  static readonly preFilterGetLinkedinIndustryPageJsonPath =
    "/api/PreFilter/GetLinkedinIndustryPageJson";
  static readonly preFilterGetOccupationMajorGroupPageJsonPath =
    "/api/PreFilter/GetOccupationMajorGroupPageJson";
  static readonly preFilterGetOccupationMinorGroupPageJsonPath =
    "/api/PreFilter/GetOccupationMinorGroupPageJson";
  static readonly preFilterGetOccupationBroadGroupPageJsonPath =
    "/api/PreFilter/GetOccupationBroadGroupPageJson";
  static readonly preFilterGetOccupationDetailedOccupationPageJsonPath =
    "/api/PreFilter/GetOccupationDetailedOccupationPageJson";
  static readonly preFilterGetOccupationOnetOccupationPageJsonPath =
    "/api/PreFilter/GetOccupationOnetOccupationPageJson";
  static readonly preFilterGetCbsaPageJsonPath =
    "/api/PreFilter/GetCbsaPageJson";
  static readonly preFilterGetZipCodePageJsonPath =
    "/api/PreFilter/GetZipCodePageJson";
  static readonly preFilterGetTitlesCountPath = "/api/PreFilter/GetTitlesCount";
  static readonly preFilterGetTitlePageJsonPath =
    "/api/PreFilter/GetTitlePageJson";
  static readonly preFilterGetCompanyPageJsonPath =
    "/api/PreFilter/GetCompanyPageJson";
  static readonly preFilterGetOrganizationsCountPath =
    "/api/PreFilter/GetOrganizationsCount";
  static readonly preFilterGetOrganizationPageJsonPath =
    "/api/PreFilter/GetOrganizationPageJson";
  static readonly preFilterTypeExportPath = "/api/PreFilter/TypeExport";
  static readonly preFilterGetPreFilterByIdPath =
    "/api/PreFilter/GetPreFilterById";
  static readonly preFilterGetPartnerEmbedPreFilterPath =
    "/api/PreFilter/GetPartnerEmbedPreFilter";
  static readonly preFilterGetPartnerEmbedPreFilterByApiKeyPath =
    "/api/PreFilter/GetPartnerEmbedPreFilterByApiKey";
  static readonly preFilterGetSubscriptionPreFiltersPath =
    "/api/PreFilter/GetSubscriptionPreFilters";
  static readonly preFilterGetInteractivePreFiltersPath =
    "/api/PreFilter/GetInteractivePreFilters";
  static readonly preFilterGetPreFilterExpandedDetailsPath =
    "/api/PreFilter/GetPreFilterExpandedDetails";
  static readonly preFilterCreatePreFilterPath =
    "/api/PreFilter/CreatePreFilter";
  static readonly preFilterUpdatePreFilterPath =
    "/api/PreFilter/UpdatePreFilter";
  static readonly preFilterSetPreFilterDefaultPath =
    "/api/PreFilter/SetPreFilterDefault";
  static readonly preFilterDeletePreFilterPath =
    "/api/PreFilter/DeletePreFilter";
  static readonly preFilterDeletePreFilterByidPath =
    "/api/PreFilter/DeletePreFilterById";
  static readonly preFilterDeletePreFilterByEmbedPath =
    "/api/PreFilter/DeletePreFilterByEmbed";
  static readonly preFilterSetPreFilterTitlesPath =
    "/api/PreFilter/SetPreFilterTitles";
  static readonly preFilterSetPreFilterFuzzyTitlesPath =
    "/api/PreFilter/SetPreFilterFuzzyTitles";
  static readonly preFilterSetPreFilterCompaniesPath =
    "/api/PreFilter/SetPreFilterCompanies";
  static readonly preFilterSetPreFilterFuzzyCompaniesPath =
    "/api/PreFilter/SetPreFilterFuzzyCompanies";
  static readonly preFilterSetPreFilterOrganizationsPath =
    "/api/PreFilter/SetPreFilterOrganizations";
  static readonly preFilterSetPreFilterFuzzyOrganizationsPath =
    "/api/PreFilter/SetPreFilterFuzzyOrganizations";
  static readonly preFilterSetPreFilterFuzzyAndOrPath =
    "/api/PreFilter/SetPreFilterFuzzyAndOr";
  static readonly preFilterSetPreFilterRegionsPath =
    "/api/PreFilter/SetPreFilterRegions";
  static readonly preFilterSetPreFilterOccupationsPath =
    "/api/PreFilter/SetPreFilterOccupations";
  static readonly preFilterSetPreFilterIndustriesPath =
    "/api/PreFilter/SetPreFilterIndustries";
  static readonly preFilterCreatePreFilterValuePath =
    "/api/PreFilter/CreatePreFilterValue";
  static readonly preFilterUpdatePreFilterValuePath =
    "/api/PreFilter/UpdatePreFilterValue";
  static readonly preFilterDeletePreFilterValuePath =
    "/api/PreFilter/DeletePreFilterValue";
  static readonly preFilterCreatePreFilterInteractivePath =
    "/api/PreFilter/CreatePreFilterInteractive";
  static readonly preFilterDeletePreFilterInteractivePath =
    "/api/PreFilter/DeletePreFilterInteractive";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetIndustrySectorPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetIndustrySectorPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetIndustrySectorPageJson(
    pageNumber?: number
  ): __Observable<string> {
    return this.preFilterGetIndustrySectorPageJsonResponse(pageNumber).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetIndustryIndustryPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetIndustryIndustryPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetIndustryIndustryPageJson(
    pageNumber?: number
  ): __Observable<string> {
    return this.preFilterGetIndustryIndustryPageJsonResponse(pageNumber).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetLinkedinIndustryPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetLinkedinIndustryPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetLinkedinIndustryPageJson(
    pageNumber?: number
  ): __Observable<string> {
    return this.preFilterGetLinkedinIndustryPageJsonResponse(pageNumber).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationMajorGroupPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetOccupationMajorGroupPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationMajorGroupPageJson(
    pageNumber?: number
  ): __Observable<string> {
    return this.preFilterGetOccupationMajorGroupPageJsonResponse(
      pageNumber
    ).pipe(__map((_r) => _r.body as string));
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationMinorGroupPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetOccupationMinorGroupPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationMinorGroupPageJson(
    pageNumber?: number
  ): __Observable<string> {
    return this.preFilterGetOccupationMinorGroupPageJsonResponse(
      pageNumber
    ).pipe(__map((_r) => _r.body as string));
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationBroadGroupPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetOccupationBroadGroupPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationBroadGroupPageJson(
    pageNumber?: number
  ): __Observable<string> {
    return this.preFilterGetOccupationBroadGroupPageJsonResponse(
      pageNumber
    ).pipe(__map((_r) => _r.body as string));
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationDetailedOccupationPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetOccupationDetailedOccupationPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationDetailedOccupationPageJson(
    pageNumber?: number
  ): __Observable<string> {
    return this.preFilterGetOccupationDetailedOccupationPageJsonResponse(
      pageNumber
    ).pipe(__map((_r) => _r.body as string));
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationOnetOccupationPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetOccupationOnetOccupationPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetOccupationOnetOccupationPageJson(
    pageNumber?: number
  ): __Observable<string> {
    return this.preFilterGetOccupationOnetOccupationPageJsonResponse(
      pageNumber
    ).pipe(__map((_r) => _r.body as string));
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetCbsaPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetCbsaPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetCbsaPageJson(pageNumber?: number): __Observable<string> {
    return this.preFilterGetCbsaPageJsonResponse(pageNumber).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetZipCodePageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetZipCodePageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetZipCodePageJson(pageNumber?: number): __Observable<string> {
    return this.preFilterGetZipCodePageJsonResponse(pageNumber).pipe(
      __map((_r) => _r.body as string)
    );
  }
  preFilterGetTitlesCountResponse(): __Observable<
    __StrictHttpResponse<number>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetTitlesCount`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  preFilterGetTitlesCount(): __Observable<number> {
    return this.preFilterGetTitlesCountResponse().pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetTitlePageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetTitlePageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetTitlePageJson(pageNumber?: number): __Observable<string> {
    return this.preFilterGetTitlePageJsonResponse(pageNumber).pipe(
      __map((_r) => _r.body as string)
    );
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetCompanyPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetCompanyPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetCompanyPageJson(pageNumber?: number): __Observable<string> {
    return this.preFilterGetCompanyPageJsonResponse(pageNumber).pipe(
      __map((_r) => _r.body as string)
    );
  }
  preFilterGetOrganizationsCountResponse(): __Observable<
    __StrictHttpResponse<number>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetOrganizationsCount`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: parseFloat((_r as HttpResponse<any>).body as string),
        }) as __StrictHttpResponse<number>;
      })
    );
  }
  preFilterGetOrganizationsCount(): __Observable<number> {
    return this.preFilterGetOrganizationsCountResponse().pipe(
      __map((_r) => _r.body as number)
    );
  }

  /**
   * @param pageNumber undefined
   */
  preFilterGetOrganizationPageJsonResponse(
    pageNumber?: number
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pageNumber != null)
      __params = __params.set("pageNumber", pageNumber.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetOrganizationPageJson`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param pageNumber undefined
   */
  preFilterGetOrganizationPageJson(pageNumber?: number): __Observable<string> {
    return this.preFilterGetOrganizationPageJsonResponse(pageNumber).pipe(
      __map((_r) => _r.body as string)
    );
  }
  preFilterTypeExportResponse(): __Observable<
    __StrictHttpResponse<TypesExportPayload>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/TypeExport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TypesExportPayload>;
      })
    );
  }
  preFilterTypeExport(): __Observable<TypesExportPayload> {
    return this.preFilterTypeExportResponse().pipe(
      __map((_r) => _r.body as TypesExportPayload)
    );
  }

  /**
   * @param preFilterId undefined
   */
  preFilterGetPreFilterByIdResponse(
    preFilterId?: number
  ): __Observable<__StrictHttpResponse<US_PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (preFilterId != null)
      __params = __params.set("preFilterId", preFilterId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetPreFilterById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<US_PreFilter>;
      })
    );
  }
  /**
   * @param preFilterId undefined
   */
  preFilterGetPreFilterById(preFilterId?: number): __Observable<US_PreFilter> {
    return this.preFilterGetPreFilterByIdResponse(preFilterId).pipe(
      __map((_r) => _r.body as US_PreFilter)
    );
  }

  /**
   * @param partnerEmbedId undefined
   */
  preFilterGetPartnerEmbedPreFilterResponse(
    partnerEmbedId?: number
  ): __Observable<__StrictHttpResponse<US_PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (partnerEmbedId != null)
      __params = __params.set("partnerEmbedId", partnerEmbedId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetPartnerEmbedPreFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<US_PreFilter>;
      })
    );
  }
  /**
   * @param partnerEmbedId undefined
   */
  preFilterGetPartnerEmbedPreFilter(
    partnerEmbedId?: number
  ): __Observable<US_PreFilter> {
    return this.preFilterGetPartnerEmbedPreFilterResponse(partnerEmbedId).pipe(
      __map((_r) => _r.body as US_PreFilter)
    );
  }

  /**
   * @param partnerEmbedApiKey undefined
   */
  preFilterGetPartnerEmbedPreFilterByApiKeyResponse(
    partnerEmbedApiKey?: string
  ): __Observable<__StrictHttpResponse<US_PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (partnerEmbedApiKey != null)
      __params = __params.set(
        "partnerEmbedApiKey",
        partnerEmbedApiKey.toString()
      );
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetPartnerEmbedPreFilterByApiKey`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<US_PreFilter>;
      })
    );
  }
  /**
   * @param partnerEmbedApiKey undefined
   */
  preFilterGetPartnerEmbedPreFilterByApiKey(
    partnerEmbedApiKey?: string
  ): __Observable<US_PreFilter> {
    return this.preFilterGetPartnerEmbedPreFilterByApiKeyResponse(
      partnerEmbedApiKey
    ).pipe(__map((_r) => _r.body as US_PreFilter));
  }

  /**
   * @param subscriptionId undefined
   */
  preFilterGetSubscriptionPreFiltersResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<Array<US_PreFilter>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetSubscriptionPreFilters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<US_PreFilter>>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  preFilterGetSubscriptionPreFilters(
    subscriptionId?: number
  ): __Observable<Array<US_PreFilter>> {
    return this.preFilterGetSubscriptionPreFiltersResponse(subscriptionId).pipe(
      __map((_r) => _r.body as Array<US_PreFilter>)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterGetInteractivePreFiltersParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `interactiveId`:
   */
  preFilterGetInteractivePreFiltersResponse(
    params: PreFilterService.PreFilterGetInteractivePreFiltersParams
  ): __Observable<__StrictHttpResponse<Array<US_PreFilter>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.subscriptionId != null)
      __params = __params.set(
        "subscriptionId",
        params.subscriptionId.toString()
      );
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetInteractivePreFilters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<US_PreFilter>>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterGetInteractivePreFiltersParams` containing the following parameters:
   *
   * - `subscriptionId`:
   *
   * - `interactiveId`:
   */
  preFilterGetInteractivePreFilters(
    params: PreFilterService.PreFilterGetInteractivePreFiltersParams
  ): __Observable<Array<US_PreFilter>> {
    return this.preFilterGetInteractivePreFiltersResponse(params).pipe(
      __map((_r) => _r.body as Array<US_PreFilter>)
    );
  }

  /**
   * @param preFilterId undefined
   */
  preFilterGetPreFilterExpandedDetailsResponse(
    preFilterId?: number
  ): __Observable<__StrictHttpResponse<PreFilterExpandedDetails>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (preFilterId != null)
      __params = __params.set("preFilterId", preFilterId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/PreFilter/GetPreFilterExpandedDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterExpandedDetails>;
      })
    );
  }
  /**
   * @param preFilterId undefined
   */
  preFilterGetPreFilterExpandedDetails(
    preFilterId?: number
  ): __Observable<PreFilterExpandedDetails> {
    return this.preFilterGetPreFilterExpandedDetailsResponse(preFilterId).pipe(
      __map((_r) => _r.body as PreFilterExpandedDetails)
    );
  }

  /**
   * @param preFilter undefined
   */
  preFilterCreatePreFilterResponse(
    preFilter: PreFilter
  ): __Observable<__StrictHttpResponse<PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilter;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/CreatePreFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilter>;
      })
    );
  }
  /**
   * @param preFilter undefined
   */
  preFilterCreatePreFilter(preFilter: PreFilter): __Observable<PreFilter> {
    return this.preFilterCreatePreFilterResponse(preFilter).pipe(
      __map((_r) => _r.body as PreFilter)
    );
  }

  /**
   * @param preFilter undefined
   */
  preFilterUpdatePreFilterResponse(
    preFilter: PreFilter
  ): __Observable<__StrictHttpResponse<PreFilter>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilter;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/UpdatePreFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilter>;
      })
    );
  }
  /**
   * @param preFilter undefined
   */
  preFilterUpdatePreFilter(preFilter: PreFilter): __Observable<PreFilter> {
    return this.preFilterUpdatePreFilterResponse(preFilter).pipe(
      __map((_r) => _r.body as PreFilter)
    );
  }

  /**
   * @param preFilterId undefined
   */
  preFilterSetPreFilterDefaultResponse(
    preFilterId: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilterId;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterDefault`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param preFilterId undefined
   */
  preFilterSetPreFilterDefault(preFilterId: number): __Observable<Blob> {
    return this.preFilterSetPreFilterDefaultResponse(preFilterId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param preFilter undefined
   */
  preFilterDeletePreFilterResponse(
    preFilter: PreFilter
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilter;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/DeletePreFilter`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param preFilter undefined
   */
  preFilterDeletePreFilter(preFilter: PreFilter): __Observable<Blob> {
    return this.preFilterDeletePreFilterResponse(preFilter).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param preFilterId undefined
   */
  preFilterDeletePreFilterByidResponse(
    preFilterId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (preFilterId != null)
      __params = __params.set("preFilterId", preFilterId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/DeletePreFilterById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param preFilterId undefined
   */
  preFilterDeletePreFilterByid(preFilterId?: number): __Observable<Blob> {
    return this.preFilterDeletePreFilterByidResponse(preFilterId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param partnerEmbedId undefined
   */
  preFilterDeletePreFilterByEmbedResponse(
    partnerEmbedId?: number
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (partnerEmbedId != null)
      __params = __params.set("partnerEmbedId", partnerEmbedId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/DeletePreFilterByEmbed`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param partnerEmbedId undefined
   */
  preFilterDeletePreFilterByEmbed(partnerEmbedId?: number): __Observable<Blob> {
    return this.preFilterDeletePreFilterByEmbedResponse(partnerEmbedId).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterTitlesParams` containing the following parameters:
   *
   * - `titles`:
   *
   * - `preFilterId`:
   */
  preFilterSetPreFilterTitlesResponse(
    params: PreFilterService.PreFilterSetPreFilterTitlesParams
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.titles || []).forEach((val) => {
      if (val != null) __params = __params.append("titles", val.toString());
    });
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterTitles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterTitlesParams` containing the following parameters:
   *
   * - `titles`:
   *
   * - `preFilterId`:
   */
  preFilterSetPreFilterTitles(
    params: PreFilterService.PreFilterSetPreFilterTitlesParams
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterTitlesResponse(params).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterFuzzyTitlesParams` containing the following parameters:
   *
   * - `titles`:
   *
   * - `preFilterId`:
   */
  preFilterSetPreFilterFuzzyTitlesResponse(
    params: PreFilterService.PreFilterSetPreFilterFuzzyTitlesParams
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.titles || []).forEach((val) => {
      if (val != null) __params = __params.append("titles", val.toString());
    });
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterFuzzyTitles`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterFuzzyTitlesParams` containing the following parameters:
   *
   * - `titles`:
   *
   * - `preFilterId`:
   */
  preFilterSetPreFilterFuzzyTitles(
    params: PreFilterService.PreFilterSetPreFilterFuzzyTitlesParams
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterFuzzyTitlesResponse(params).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterCompaniesParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `companies`:
   */
  preFilterSetPreFilterCompaniesResponse(
    params: PreFilterService.PreFilterSetPreFilterCompaniesParams
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    (params.companies || []).forEach((val) => {
      if (val != null) __params = __params.append("companies", val.toString());
    });
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterCompanies`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterCompaniesParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `companies`:
   */
  preFilterSetPreFilterCompanies(
    params: PreFilterService.PreFilterSetPreFilterCompaniesParams
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterCompaniesResponse(params).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterFuzzyCompaniesParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `companies`:
   */
  preFilterSetPreFilterFuzzyCompaniesResponse(
    params: PreFilterService.PreFilterSetPreFilterFuzzyCompaniesParams
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    (params.companies || []).forEach((val) => {
      if (val != null) __params = __params.append("companies", val.toString());
    });
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterFuzzyCompanies`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterFuzzyCompaniesParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `companies`:
   */
  preFilterSetPreFilterFuzzyCompanies(
    params: PreFilterService.PreFilterSetPreFilterFuzzyCompaniesParams
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterFuzzyCompaniesResponse(params).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterOrganizationsParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `organizations`:
   */
  preFilterSetPreFilterOrganizationsResponse(
    params: PreFilterService.PreFilterSetPreFilterOrganizationsParams
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    (params.organizations || []).forEach((val) => {
      if (val != null)
        __params = __params.append("organizations", val.toString());
    });
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterOrganizations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterOrganizationsParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `organizations`:
   */
  preFilterSetPreFilterOrganizations(
    params: PreFilterService.PreFilterSetPreFilterOrganizationsParams
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterOrganizationsResponse(params).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterFuzzyOrganizationsParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `organizations`:
   */
  preFilterSetPreFilterFuzzyOrganizationsResponse(
    params: PreFilterService.PreFilterSetPreFilterFuzzyOrganizationsParams
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    (params.organizations || []).forEach((val) => {
      if (val != null)
        __params = __params.append("organizations", val.toString());
    });
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterFuzzyOrganizations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterFuzzyOrganizationsParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `organizations`:
   */
  preFilterSetPreFilterFuzzyOrganizations(
    params: PreFilterService.PreFilterSetPreFilterFuzzyOrganizationsParams
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterFuzzyOrganizationsResponse(params).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterFuzzyAndOrParams` containing the following parameters:
   *
   * - `titlesAnd`:
   *
   * - `preFilterId`:
   *
   * - `companiesAnd`:
   */
  preFilterSetPreFilterFuzzyAndOrResponse(
    params: PreFilterService.PreFilterSetPreFilterFuzzyAndOrParams
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.titlesAnd != null)
      __params = __params.set("titlesAnd", params.titlesAnd.toString());
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    if (params.companiesAnd != null)
      __params = __params.set("companiesAnd", params.companiesAnd.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterFuzzyAndOr`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === "true",
        }) as __StrictHttpResponse<boolean>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterSetPreFilterFuzzyAndOrParams` containing the following parameters:
   *
   * - `titlesAnd`:
   *
   * - `preFilterId`:
   *
   * - `companiesAnd`:
   */
  preFilterSetPreFilterFuzzyAndOr(
    params: PreFilterService.PreFilterSetPreFilterFuzzyAndOrParams
  ): __Observable<boolean> {
    return this.preFilterSetPreFilterFuzzyAndOrResponse(params).pipe(
      __map((_r) => _r.body as boolean)
    );
  }

  /**
   * @param payload undefined
   */
  preFilterSetPreFilterRegionsResponse(
    payload: SetRegionsPayload
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterRegions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param payload undefined
   */
  preFilterSetPreFilterRegions(
    payload: SetRegionsPayload
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterRegionsResponse(payload).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param payload undefined
   */
  preFilterSetPreFilterOccupationsResponse(
    payload: SetOccupationsPayload
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterOccupations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param payload undefined
   */
  preFilterSetPreFilterOccupations(
    payload: SetOccupationsPayload
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterOccupationsResponse(payload).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param payload undefined
   */
  preFilterSetPreFilterIndustriesResponse(
    payload: SetIndustriesPayload
  ): __Observable<__StrictHttpResponse<Array<PreFilterValue>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = payload;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/SetPreFilterIndustries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PreFilterValue>>;
      })
    );
  }
  /**
   * @param payload undefined
   */
  preFilterSetPreFilterIndustries(
    payload: SetIndustriesPayload
  ): __Observable<Array<PreFilterValue>> {
    return this.preFilterSetPreFilterIndustriesResponse(payload).pipe(
      __map((_r) => _r.body as Array<PreFilterValue>)
    );
  }

  /**
   * @param preFilterValue undefined
   */
  preFilterCreatePreFilterValueResponse(
    preFilterValue: PreFilterValue
  ): __Observable<__StrictHttpResponse<PreFilterValue>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilterValue;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/CreatePreFilterValue`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterValue>;
      })
    );
  }
  /**
   * @param preFilterValue undefined
   */
  preFilterCreatePreFilterValue(
    preFilterValue: PreFilterValue
  ): __Observable<PreFilterValue> {
    return this.preFilterCreatePreFilterValueResponse(preFilterValue).pipe(
      __map((_r) => _r.body as PreFilterValue)
    );
  }

  /**
   * @param preFilterValue undefined
   */
  preFilterUpdatePreFilterValueResponse(
    preFilterValue: PreFilterValue
  ): __Observable<__StrictHttpResponse<PreFilterValue>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilterValue;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/UpdatePreFilterValue`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterValue>;
      })
    );
  }
  /**
   * @param preFilterValue undefined
   */
  preFilterUpdatePreFilterValue(
    preFilterValue: PreFilterValue
  ): __Observable<PreFilterValue> {
    return this.preFilterUpdatePreFilterValueResponse(preFilterValue).pipe(
      __map((_r) => _r.body as PreFilterValue)
    );
  }

  /**
   * @param preFilterValue undefined
   */
  preFilterDeletePreFilterValueResponse(
    preFilterValue: PreFilterValue
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = preFilterValue;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/DeletePreFilterValue`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param preFilterValue undefined
   */
  preFilterDeletePreFilterValue(
    preFilterValue: PreFilterValue
  ): __Observable<Blob> {
    return this.preFilterDeletePreFilterValueResponse(preFilterValue).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterCreatePreFilterInteractiveParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `interactiveId`:
   */
  preFilterCreatePreFilterInteractiveResponse(
    params: PreFilterService.PreFilterCreatePreFilterInteractiveParams
  ): __Observable<__StrictHttpResponse<PreFilterInteractive>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/CreatePreFilterInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PreFilterInteractive>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterCreatePreFilterInteractiveParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `interactiveId`:
   */
  preFilterCreatePreFilterInteractive(
    params: PreFilterService.PreFilterCreatePreFilterInteractiveParams
  ): __Observable<PreFilterInteractive> {
    return this.preFilterCreatePreFilterInteractiveResponse(params).pipe(
      __map((_r) => _r.body as PreFilterInteractive)
    );
  }

  /**
   * @param params The `PreFilterService.PreFilterDeletePreFilterInteractiveParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `interactiveId`:
   */
  preFilterDeletePreFilterInteractiveResponse(
    params: PreFilterService.PreFilterDeletePreFilterInteractiveParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.preFilterId != null)
      __params = __params.set("preFilterId", params.preFilterId.toString());
    if (params.interactiveId != null)
      __params = __params.set("interactiveId", params.interactiveId.toString());
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/PreFilter/DeletePreFilterInteractive`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `PreFilterService.PreFilterDeletePreFilterInteractiveParams` containing the following parameters:
   *
   * - `preFilterId`:
   *
   * - `interactiveId`:
   */
  preFilterDeletePreFilterInteractive(
    params: PreFilterService.PreFilterDeletePreFilterInteractiveParams
  ): __Observable<Blob> {
    return this.preFilterDeletePreFilterInteractiveResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }
}

module PreFilterService {
  /**
   * Parameters for PreFilterGetInteractivePreFilters
   */
  export interface PreFilterGetInteractivePreFiltersParams {
    subscriptionId?: number;
    interactiveId?: number;
  }

  /**
   * Parameters for PreFilterSetPreFilterTitles
   */
  export interface PreFilterSetPreFilterTitlesParams {
    titles?: null | Array<string>;
    preFilterId?: number;
  }

  /**
   * Parameters for PreFilterSetPreFilterFuzzyTitles
   */
  export interface PreFilterSetPreFilterFuzzyTitlesParams {
    titles?: null | Array<string>;
    preFilterId?: number;
  }

  /**
   * Parameters for PreFilterSetPreFilterCompanies
   */
  export interface PreFilterSetPreFilterCompaniesParams {
    preFilterId?: number;
    companies?: null | Array<string>;
  }

  /**
   * Parameters for PreFilterSetPreFilterFuzzyCompanies
   */
  export interface PreFilterSetPreFilterFuzzyCompaniesParams {
    preFilterId?: number;
    companies?: null | Array<string>;
  }

  /**
   * Parameters for PreFilterSetPreFilterOrganizations
   */
  export interface PreFilterSetPreFilterOrganizationsParams {
    preFilterId?: number;
    organizations?: null | Array<string>;
  }

  /**
   * Parameters for PreFilterSetPreFilterFuzzyOrganizations
   */
  export interface PreFilterSetPreFilterFuzzyOrganizationsParams {
    preFilterId?: number;
    organizations?: null | Array<string>;
  }

  /**
   * Parameters for PreFilterSetPreFilterFuzzyAndOr
   */
  export interface PreFilterSetPreFilterFuzzyAndOrParams {
    titlesAnd?: boolean;
    preFilterId?: number;
    companiesAnd?: boolean;
  }

  /**
   * Parameters for PreFilterCreatePreFilterInteractive
   */
  export interface PreFilterCreatePreFilterInteractiveParams {
    preFilterId?: number;
    interactiveId?: number;
  }

  /**
   * Parameters for PreFilterDeletePreFilterInteractive
   */
  export interface PreFilterDeletePreFilterInteractiveParams {
    preFilterId?: number;
    interactiveId?: number;
  }
}

export { PreFilterService };
